module.exports = __webpack_public_path__ + "img/feiyin-about.d303c320.png";